import { Row, Col, Card, Table, Button, Input, Tooltip, Avatar } from "antd";
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import useDebounce from "../../../hooks/useDebounce";
import moment from 'moment';
import { formatDate } from "../../../helper/DateHelper";
import { useNavigate } from "react-router";
import ShowTotal from "../../../components/ShowTotal";
import apiPath from "../../../constants/apiPath";
import { useParams } from "react-router";
import { getSortOrder } from "../../../constants/conts";
const Search = Input.Search;

function Index() {

  const sectionName = "Service / Product Bucket";
  const routeName = "service-product";

  const api = {
    list  : apiPath.spListUser,
  }

  const [searchText, setSearchText] = useState('');
  const { request } = useRequest()
  const params =   useParams();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [sortBy, setSortBy]           =   useState('');
  const lastFiltersRef                =   useRef({});
  const debouncedSearchText = useDebounce(searchText, 300);
  const navigate = useNavigate();

  const view = (record) => {
    navigate(`/user/${routeName}/view/${params?.user_id}/${record?._id}`)
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 250,
      sorter: true,
      sortOrder: getSortOrder(sortBy, "name"),
      render: (_, { brands, _id }) => {
        const brandsArr   =   brands[0];
        const castName = brandsArr?.brand?.name ? brandsArr?.brand?.name : 'Service Not Available';
        return (
          <>
            <Avatar className="cap" size={40}> {castName?.charAt(0)} </Avatar>
            <a style={{ marginLeft: 12 }} className="cap avatar-text" onClick={(e) => view(_id)}>{castName}</a>
          </>
        );
      },
    },
    {
      title: "PSL Name",
      dataIndex: "psl_name",
      key: "psl_name",
      render: (_, { brands, _id }) => {
        const brandsArr   =   brands[0];
        const castName = brandsArr?.psl_list[0] ? brandsArr?.psl_list[0] : 'Name Not Available';
        return (
          castName && castName.psl_name ? <span className="cap">{castName.psl_name}</span> : '-'
        );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "created_at"),
      render: (_, { created_at }) => {
        return (
          formatDate(created_at)
        );
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>
            <Tooltip title={"View " + sectionName} color={"purple"} key={"view" + routeName}>
              <Button title="View" onClick={() => view(record)}>
                <i className="fa fa-light fa-eye"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true)
    fetchData(pagination, lastFiltersRef.current, sortBy)
  }, [refresh, debouncedSearchText, sortBy, pagination.current, pagination.pageSize])

  const fetchData = (pagination, filters, sortValue = '') => {
   
    const filterActive = filters ? filters.is_active : null

    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(',') : ''}` +
        `&page=${pagination.current}` +
        `&limit=${pagination.pageSize}` +
        `&search=${debouncedSearchText}` +
        `&user_id=${params.user_id}` +
        `&sort=${sortValue || ''}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        setList(data.data.list.docs)
        setPagination(prev => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.data.list.totalDocs
        }));
      },
      onError: (error) => {
        console.log(error)
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }
  
  const handleChange = (pag, filters, sorter) => {
    const { order, field } = sorter || {};

    let nextSort = '';
    if (order) {
      nextSort = `${field}:${order === 'ascend' ? 'asc' : 'desc'}`;
    }

    lastFiltersRef.current = filters || {};

    setSortBy(nextSort);

    setPagination(prev => ({
      ...prev,
      current: pag?.current || 1,
      pageSize: pag?.pageSize || prev.pageSize,
    }));

    fetchData({ current: pag?.current || 1, pageSize: pag?.pageSize || pagination.pageSize }, filters, nextSort);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <div className="tabled customerMain">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName}
              extra={
                <>
                  <div className="searchOuter">
                    <Search className="mainSearch"
                      size="large"
                      allowClear
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      placeholder="Search By Name"
                    />
                  </div>
                  
                  {/* <div className="button_group">
                    <Button onClick={(e) => { setVisible(true); setSearchText(''); }}>Add New {sectionName}</Button>
                  </div> */}
                </>
              }
            >

              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              <div className="custom-tab">
               <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 20,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50", '100'],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>

            </Card>
          </Col>
        </Row>
      </div>

    </>
  );
}
export default Index;
